import { render, staticRenderFns } from "./OperaTooltip.vue?vue&type=template&id=a20a2926"
import script from "./OperaTooltip.vue?vue&type=script&setup=true&lang=js"
export * from "./OperaTooltip.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports